import { Flex, Text } from "@chakra-ui/react";
import SanctionBanner from "@components/SanctionBanner";
import Tooltip from "@components/Tooltip";
import VaultHeader from "@components/VaultHeader";
import useSanction from "@hooks/useSanction";
import useYieldVaultData from "@hooks/useYieldVaultData";
import { YIELD_TEXT_STRINGS } from "./contants";
import YieldDWBSection from "./DepositWithdraw";
import YieldOverviewSection from "./Overview";
import YieldPortfolioSection from "./Portfolio";

const YieldVault = () => {
  const {
    isLoadingAPYData,
    formattedApy,
    formattedTvl,
    isLoadingTotalStaked,
    formattedETHStaked,
  } = useYieldVaultData();

  const { isSanctioned } = useSanction();

  return (
    <>
      <Flex direction={"column"} alignItems={"center"}>
        <Flex flexDir="column" w="100%" maxW={"736px"}>
          {isSanctioned && <SanctionBanner />}
        </Flex>
      </Flex>
      <Flex
        direction={"column"}
        alignItems={"center"}
        gap="20px"
        p="16px"
        pointerEvents={isSanctioned ? "none" : "auto"}
        opacity={isSanctioned ? 0.5 : 1}
      >
        <VaultHeader
          isLoadingAPYData={isLoadingAPYData}
          isLoadingTotalStaked={isLoadingTotalStaked}
          totalStaked={formattedTvl}
          totalStakedEth={formattedETHStaked}
          apyValue={formattedApy}
          apyLabel={YIELD_TEXT_STRINGS.HEADER.STATS.APY}
          totalStakedLabel={YIELD_TEXT_STRINGS.HEADER.STATS.TVL}
          title={YIELD_TEXT_STRINGS.HEADER.TITLE}
          auditedUrl="https://kelp.gitbook.io/kelp/kelp-gain/high-growth-gain"
          logo={{
            src: "/assets/vaults/hgeth.svg",
            label: "HgETH Logo",
          }}
          tooltipComponent={
            <Tooltip
              placement="top"
              label={
                <Text fontWeight="400">
                  Projected APY based on rewards and points earned by the
                  vault&apos;s positions. <br />
                  <strong>
                    Check &apos;APR Reports&apos; section for details
                  </strong>
                  {/* <Link
                  isExternal
                  href="https://kelp.gitbook.io/kelp/kelp-gain/high-growth-gain#strategy-and-target-apr"
                  fontWeight="700"
                >
                  Click here{" "}
                </Link>
                for a detailed breakdown of the Expected APY. */}
                </Text>
              }
            />
          }
        />
        <YieldDWBSection />
        <YieldPortfolioSection />
        <YieldOverviewSection />
      </Flex>
    </>
  );
};

export default YieldVault;
